export default __webpack_public_path__ + "SolutionIcon5.52a5dbb.png";